import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-311aaa11"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-l"
}
const _hoisted_2 = { class: "sub-heading" }
const _hoisted_3 = {
  key: 0,
  class: "item"
}
const _hoisted_4 = {
  key: 1,
  class: "item"
}
const _hoisted_5 = { class: "text-empty-state" }
const _hoisted_6 = { class: "sub-heading" }
const _hoisted_7 = {
  key: 1,
  class: "item"
}
const _hoisted_8 = { class: "text-empty-state" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_content_loader = _resolveComponent("base-content-loader")!
  const _component_case_contact = _resolveComponent("case-contact")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_base_content_loader, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.projectManager)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.translate('details.primaryContact')), 1),
                  (_ctx.projectManager)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_case_contact, {
                          "contact-type": "project_manager",
                          contact: _ctx.projectManager
                        }, null, 8, ["contact"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.translate('shared.noProjectManagerAssigned')), 1)
                      ]))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.translate('details.secondaryContacts')), 1),
            _createElementVNode("ul", null, [
              (_ctx.hasSecondaryContacts)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.secondaryContacts, (contact) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "item",
                      key: contact.email
                    }, [
                      _createVNode(_component_case_contact, {
                        "contact-type": "technician",
                        contact: contact
                      }, null, 8, ["contact"])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.translate('shared.noOtherPolygonContactsAssigned')), 1)
                  ]))
            ])
          ], 64))
    ]),
    _: 1
  }))
}